/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('ContractCtrl', function($scope, identity, features) {
  $scope.me             = identity;
  $scope.today          = moment().format('YYYY-MM-DD hh:mm:ss');
  $scope.accordion      = {
    next_schedules_open: false,
    absences_open:       false
  };
  $scope.now            = moment().format('YYYY-MM-DD');

  $scope.features = features;

  for (let period of $scope.contract.periods) {
    if ((0 === period.expected) && (period.start < $scope.today) && (period.end > $scope.today)) {
      $scope.current_period = period;
      break;
    } else if ((0 !== period.expected) && (period.start < $scope.today) && (period.end > $scope.today)) {
      $scope.current_period = period;
    }
  }

  $scope.toHour = time => Math.floor((time) / 60);

  // On prend la plupart du temps l'arrondi en dessous car on utilise les minutes par la suite
  // dans le cas de l'elearning restant on prend seulement les heures pleines, donc on arrondit au-dessus
  $scope.toHourAbove = time => Math.ceil((time) / 60);

  $scope.toMinute = time => Math.floor((time) % 60);

  $scope.handleEverything = function(period, schedules) {
    handleTodaySchedules(period, schedules);
    handleProgressBar(period);
  };

  var handleTodaySchedules = function(period, schedules) {
    const today        = moment();
    const period_start = moment(period.start);
    const period_end   = moment(period.end);

    $scope.nextSchedules      = [];
    $scope.today_schedules    = [];
    $scope.total_log_possible = 0;
    $scope.log_possible_today = 0;

    const result = [];
    for (let schedule of schedules) {
      const schedule_day  = moment(schedule.end);
      const schedule_diff = moment(schedule.end).diff(moment(schedule.start), 'minutes', true);
	  
      if (schedule_day.format('YYYY-MM-DD') === today.format('YYYY-MM-DD')) {
        $scope.today_schedules.push(schedule);
      }
      if (schedule_day.format('YYYY-MM-DD') > today.format('YYYY-MM-DD')) {
        $scope.nextSchedules.push(schedule);
      }
      if ((schedule_day >= period_start) && (schedule_day <= period_end)) {
        $scope.total_log_possible += schedule_diff;
      }
      if ((schedule_day >= period_start) && (schedule_day <= today)) {
        result.push($scope.log_possible_today += schedule_diff);
      } else {
        result.push(undefined);
      }
	}
  };

  var handleProgressBar = function(period) {
    // Gestion de la bar de temps de log
    $scope.log_done             = Math.min(period.expected * 60, (period.log * 60) + period.log_minutes);
    $scope.log_remaining        = Math.max(0, (period.expected * 60) - ($scope.log_done));
    $scope.log_percentage       = Math.min(100, ($scope.log_done * 100) / (period.expected * 60));
    $scope.log_percentage_today = ($scope.log_possible_today * 100) / ($scope.total_log_possible);
    $scope.possible_remaining   = $scope.total_log_possible - $scope.log_possible_today;
    $scope.elearning_absence    = $scope.contract.total_expected - $scope.contract.total_log;
    //On donne une valeur par défaut à absence_done
    //Et à absence_percentage pour eviter l'affichage de NaN en front.
    $scope.absence_done         = 0;
    $scope.absence_percentage   = 0;

    // Gestion de la bar d'absence
    if (0 !== $scope.elearning_absence) {
      $scope.absence_done       = Math.max(0, ((period.log * 60) + period.log_minutes) - (period.expected * 60));
      $scope.absence_percentage = Math.min(100, ($scope.absence_done * 100) / ($scope.elearning_absence * 60));
    }

    const margin_percentage  = (($scope.possible_remaining - $scope.log_remaining) * 100) / $scope.log_remaining;

	switch (true) {
	case (margin_percentage <= 20):
	  $scope.type_bar = "danger"; break;
	case (margin_percentage <= 40):
	  $scope.type_bar = "warning"; break;	  
	default:
	  $scope.type_bar = 'success';
	}
    
  };

  const handleAbsences = function(absences) {
    $scope.absences       = { };
    $scope.total_absences = 0;

    return absences.filter(absence => absence.notified).map(function(absence) {
      const absence_day = moment(absence.start).format('YYYY-MM-DD');
      $scope.total_absences += absence.expected;

      if ($scope.absences[absence_day]) {
        return $scope.absences[absence_day] += absence.expected;
      } else {
        return $scope.absences[absence_day] = absence.expected;
      }
    });
  };

  handleAbsences($scope.contract.absences.catchings);

  const handleRatp = function(rattrapages) {
    $scope.ratp_to_do = { };
    return rattrapages.forEach(function(rattrapage) {
      // On informe des rattrapages seulement si leur date est dans le futur
      if (rattrapage.start > $scope.now) {
        let needle;
        const formatted_ratp       = { };
        formatted_ratp.name  = moment(rattrapage.start).format('YYYY-MM-DD');
        formatted_ratp.start = moment(rattrapage.start).format('HH:mm');
        formatted_ratp.end   = moment(rattrapage.end).format('HH:mm');

        // Dans le cas où il y a deux ratp pour une journée, on fusionne en un seul ratp avec l'heure de
        // début la plus petite et l'heure de fin la plus grande des deux.
        if ((needle = formatted_ratp.name, Object.keys($scope.ratp_to_do).includes(needle))) {
          if ($scope.ratp_to_do[formatted_ratp.name].end < formatted_ratp.end) {
            $scope.ratp_to_do[formatted_ratp.name].end = formatted_ratp.end;
          }
          if ($scope.ratp_to_do[formatted_ratp.name].start > formatted_ratp.start) {
            $scope.ratp_to_do[formatted_ratp.name].start = formatted_ratp.start;
          }
        } else {
          $scope.ratp_to_do[formatted_ratp.name] = {
            start : formatted_ratp.start,
            end : formatted_ratp.end
          };
        }
      }
    });
  };

  handleRatp($scope.contract.absences.ratp_periods);

  return $scope.check_if_ratp = !!Object.keys($scope.ratp_to_do).length;
});
